/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Fokus_NInputs */

const en_tut_fokus_n = /** @type {(inputs: Tut_Fokus_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus session limits: 1–120 minutes of focus, 1–30 of break, 1–8 cycles, four hours in total. Status objects only read; they never run an agent and never change any work.`)
};

const id_tut_fokus_n = /** @type {(inputs: Tut_Fokus_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batas sesi fokus: 1–120 menit fokus, 1–30 menit istirahat, 1–8 siklus, total maksimal empat jam. Objek status hanya membaca; ia tidak menjalankan agen dan tidak mengubah pekerjaan apa pun.`)
};

/**
* | output |
* | --- |
* | "Focus session limits: 1–120 minutes of focus, 1–30 of break, 1–8 cycles, four hours in total. Status objects only read; they never run an agent and never cha..." |
*
* @param {Tut_Fokus_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_fokus_n = /** @type {((inputs?: Tut_Fokus_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Fokus_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_fokus_n(inputs)
	return en_tut_fokus_n(inputs)
});